import { CloudOff } from "lucide-react";

export function ReportsOfflineState() {
  return (
    <div className="flex h-full w-full items-center justify-center px-10 py-12">
      <div className="flex max-w-sm flex-col items-center gap-4 text-center">
        <div className="flex h-24 w-24 items-center justify-center rounded-full bg-muted">
          <CloudOff className="h-12 w-12 text-muted-foreground" />
        </div>
        <div className="space-y-2">
          <h3 className="text-lg font-semibold">
            Reports aren&apos;t available offline
          </h3>
          <p className="text-sm text-muted-foreground">
            You&apos;ll need an internet connection to view or generate
            reports. They&apos;ll load automatically once you&apos;re back
            online.
          </p>
        </div>
      </div>
    </div>
  );
}
